import { Language } from "@faire/web-api/indigofair/languages/Language";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";

import { getLocaleKey } from "@faire/retailer/serialized-data/getLocaleKey";
import { getSessionCountry } from "@faire/retailer/serialized-data/getSessionCountry";
import { RetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

import { isLoggedInRetailer } from "./isLoggedInRetailer";

export const shouldShowImprintPage = (): boolean => {
  const countryCode = isLoggedInRetailer()
    ? RetailerStore.get().retailerCountry
    : getSessionCountry();

  return (
    countryCode === THREE_LETTER_PRIMARY_COUNTRY_CODES.DEU &&
    getLocaleKey()?.language === Language.DEU
  );
};
